(() => {
  if (customElements.get('sw-collection-description')) return;
  class CollectionDescription extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.enhance(), { once: true });
      } else {
        this.enhance();
      }
    }
    enhance() {
      const content = this.querySelector('.sw-description-content');
      if (!content || content.dataset.enhanced) return;
      content.dataset.enhanced = 'true';
      const normalize = text => text.trim().replace(/\s+/g, ' ').toLowerCase();
      const title = normalize(this.dataset.title || '');
      content.querySelectorAll('h1').forEach(heading => {
        if (normalize(heading.textContent) === title) heading.remove();
        else {
          const replacement = document.createElement('h2');
          replacement.append(...heading.childNodes);
          heading.replaceWith(replacement);
        }
      });
      const groups = [];
      let group = { heading: null, nodes: [] };
      for (const node of Array.from(content.childNodes)) {
        if (node.nodeType === 1 && node.tagName === 'H2') {
          groups.push(group);
          group = { heading: node, nodes: [] };
        } else group.nodes.push(node);
      }
      groups.push(group);
      for (const part of groups) {
        if (!part.heading) continue;
        const meaningful = part.nodes.some(node => node.textContent.trim() || (node.nodeType === 1 && node.querySelector('img,video,iframe')));
        if (!meaningful) { part.heading.remove(); part.nodes.forEach(node => node.remove()); continue; }
        const faq = /frequently asked|\bfaqs?\b|questions.*answered/i.test(part.heading.textContent);
        if (faq) {
          part.heading.classList.add('sw-description-heading');
          let question = null;
          let answers = [];
          const finish = () => {
            if (!question) return;
            if (answers.some(node => node.textContent.trim())) this.makeDisclosure(question, answers, 'sw-description-faq');
          };
          for (const node of part.nodes) {
            if (node.nodeType === 1 && node.tagName === 'H3') {
              finish(); question = node; answers = [];
            } else if (question) answers.push(node);
          }
          finish();
        } else {
          const collectionLinks = part.nodes.reduce((count, node) => count + (node.nodeType === 1 ? node.querySelectorAll('a[href*="/collections/"]').length : 0), 0);
          if (collectionLinks >= 2 && /^(shop|explore|browse)\b/i.test(part.heading.textContent.trim())) {
            const section = document.createElement('section');
            section.className = 'sw-description-explore';
            part.heading.before(section);
            section.append(part.heading, ...part.nodes);
            part.heading.classList.add('sw-description-heading');
            section.querySelectorAll('li').forEach(item => {
              if (item.querySelector('a[href*="/collections/"]')) item.classList.add('sw-description-link-item');
            });
            const subheadings = Array.from(section.children).filter(node => node.tagName === 'H3' && node.querySelector('a[href*="/collections/"]'));
            if (subheadings.length) {
              const grid = document.createElement('div');
              grid.className = 'sw-description-link-grid';
              subheadings[0].before(grid);
              for (const heading of subheadings) {
                const card = document.createElement('div');
                card.className = 'sw-description-link-item';
                const nodes = [heading];
                let next = heading.nextSibling;
                while (next && !(next.nodeType === 1 && /^H[23]$/.test(next.tagName))) {
                  nodes.push(next); next = next.nextSibling;
                }
                grid.append(card);
                card.append(...nodes);
              }
            }
          } else this.makeDisclosure(part.heading, part.nodes, 'sw-description-guide');
        }
      }
    }
    makeDisclosure(heading, nodes, className) {
      const details = document.createElement('details');
      details.className = className;
      const summary = document.createElement('summary');
      const label = document.createElement(heading.tagName.toLowerCase());
      label.append(...heading.childNodes);
      summary.append(label);
      const body = document.createElement('div');
      body.className = 'sw-description-answer';
      heading.before(details);
      details.append(summary, body);
      body.append(...nodes);
      heading.remove();
    }
  }
  customElements.define('sw-collection-description', CollectionDescription);
})();
